import { useState } from 'react';

import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.home.bgColor};
`;

const LogoView = styled.div`
  transform: scale(1.8);
`;

const GreenPath = styled.path`
  opacity: 0;
  transform: translateY(-30px);
  animation: greenDrop 0.6s ease-in-out 0.4s forwards;
  fill: ${(props) => props.theme.global.mainColor};

  @keyframes greenDrop {
    0% {
      opacity: 0;
      transform: translateY(-30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const YellowPath = styled.path`
  opacity: 0;
  transform: translateY(-30px);
  animation: yellowDrop 0.6s ease-in-out 0.2s forwards;
  fill: ${(props) => props.theme.global.mainColor};

  @keyframes yellowDrop {
    0% {
      opacity: 0;
      transform: translateY(-30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const BluePath = styled.path`
  opacity: 0;
  transform: translateY(-30px);
  animation: blueDrop 0.6s ease-in-out 0s forwards;
  fill: ${(props) => props.theme.global.mainColor};

  @keyframes blueDrop {
    0% {
      opacity: 0;
      transform: translateY(-30px);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ProgressBarTrack = styled.div`
  width: 180px;
  border-radius: 100px;
  height: 7px;
  background-color: ${(props) => props.theme.global.whiteTextColor};
  overflow: hidden;
`;

const ProgressBar = styled.div`
  height: 100%;
  background-color: ${(props) => props.theme.global.mainColor};
  animation: fill 3s ease-in-out forwards;

  @keyframes fill {
    0% {
      width: 0%;
    }

    30% {
      width: 50%;
    }

    60% {
      width: 50%;
    }

    100% {
      width: 80%;
    }
  }
`;

const EditorLoader = () => {
  const [show, setShow] = useState(true);

  const onGreenPathAnimationEnd = () => {
    setTimeout(() => {
      setShow(false);
      setTimeout(() => {
        setShow(true);
      });
    }, 800);
  };

  return (
    <Container>
      <LogoView>
        <svg width="113" height="102" viewBox="0 0 113 102" fill="none" xmlns="http://www.w3.org/2000/svg">
          {show && (
            <>
              <GreenPath
                onAnimationEnd={onGreenPathAnimationEnd}
                d="M50.3832 43.7024L37.221 47.5747C37.1115 47.6064 37.002 47.5235 37.002 47.4088V33.173C37.002 33.0777 37.0785 33 37.1741 33H49.8112C52.1689 33 54.0815 34.9396 54.0815 37.3346V38.7095C54.0815 41.0233 52.574 43.06 50.385 43.7042L50.3832 43.7024Z"
              />
              <BluePath d="M53.9074 68.0007H37.1704C37.0765 68.0007 37 67.9231 37 67.8278V51.6788C37 51.6012 37.0504 51.5341 37.1235 51.5129L48.1974 48.2443C51.5132 47.2206 54.1387 48.9732 54.0778 52.2912V67.826C54.0778 67.9213 54.0013 67.999 53.9074 67.999V68.0007Z" />
              <YellowPath d="M70.7294 33H58.0923C57.9984 33 57.9219 33.0777 57.9219 33.173V67.8253C57.9219 67.9206 57.9984 67.9982 58.0923 67.9982H64.7951C64.889 67.9982 64.9655 67.9206 64.9655 67.8253V44.1648C64.9655 44.0925 65.0107 44.0272 65.0785 44.0025L67.1128 43.2524C67.5214 43.1006 67.9544 43.4095 67.9544 43.8507V67.8253C67.9544 67.9206 68.0309 67.9982 68.1248 67.9982H74.8276C74.9215 67.9982 74.998 67.9206 74.998 67.8253V37.3346C74.998 34.9414 73.0871 33 70.7276 33H70.7294Z" />
            </>
          )}
        </svg>
      </LogoView>
      <ProgressBarTrack>
        <ProgressBar></ProgressBar>
      </ProgressBarTrack>
    </Container>
  );
};

export default EditorLoader;
